import NoDataImg from "@/assets/noData.svg";

const NoData = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img src={NoDataImg} className="w-[200px] h-auto" />
    </div>
  )
}

export default NoData;